/** 首充/冻结金额来自 GET /payment/hyperpay/card/cardInfo 的 firstRechargeAmount */
export function getFirstRechargeAmount(cardInfo) {
  if (!cardInfo) return "";
  const raw = cardInfo.firstRechargeAmount ?? cardInfo.first_recharge_amount;
  if (raw === undefined || raw === null || raw === "") return "";
  return String(raw);
}

export function formatFreezeAmount(cardInfo, unit = "U") {
  const amount = getFirstRechargeAmount(cardInfo);
  return amount ? `${amount}${unit}` : "--";
}
